const Contact = () => import ( /* webpackChunkName: "contact" */ './Contact');

export default {
  path: '/contact-us',
  component: Contact,
  name: 'contact',
};